import React, {Component} from 'react';
import {connect} from 'react-redux';
import {checkAppExistApi, checkSession} from "../../api/api";
import {
  APP_CHECK_RESULT,
  MESSAGE_EVENT_TYPE,
  APP_CHECK_LOADED,
  APP_CHECK_UNLOADED
} from "../../constants/postMessages";
import {checkOrigin, getOrigin} from "../../actions/storage";


export class AppCheck extends Component {

  checkAppExist = (e) => {
      if (checkOrigin(e.origin)) {
          checkAppExistApi(e.data).then(response => {
                  window.parent.postMessage(JSON.stringify({
                      type: APP_CHECK_RESULT,
                      data: {
                          appId: e.data,
                          status: response.status
                      }
                  }), getOrigin());
              }
          );
      }
  }

  componentDidMount() {
    if (checkSession(this.props.history)) {
      window.addEventListener(MESSAGE_EVENT_TYPE, this.checkAppExist, false);
      window.parent.postMessage(APP_CHECK_LOADED, getOrigin());
    }
  }

  componentWillUnmount() {
    window.parent.postMessage(APP_CHECK_UNLOADED, getOrigin());
    window.removeEventListener(MESSAGE_EVENT_TYPE, this.checkAppExist);
  }

  render() {
    return (<div/>);
  }
}

export default connect()(AppCheck);
